// Реестр префетча lazy-чанков экранов. Экраны регистрируют лоадер в routes.tsx, а адаптер
// вызывает его из navigation.preload — чтобы переход (например разворот блока Сервисов
// с Главной) не ждал загрузку чанка. Повторный вызов лоадера бесплатен: динамический
// import кешируется.
type ScreenLoader = () => Promise<unknown>

const loaders = new Map<string, ScreenLoader>()

export function registerScreenPreload(key: string, loader: ScreenLoader) {
  loaders.set(key, loader)
}

export function preloadScreen(key: string) {
  loaders
    .get(key)?.()
    .catch(() => undefined)
}
